import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { MessageCircle, Mail, Phone } from "lucide-react";
import { LOGO, formatPhone, telHref } from "../lib/menu";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const links = [
  { to: "/", label: "Home" },
  { to: "/menu-samenstellen", label: "Bestel Direct" },
  { to: "/verhalen", label: "Verhalen" },
  { to: "/deel-jouw-tori", label: "Deel jouw Tori" },
  { to: "/contact", label: "Contact" },
  { to: "/algemene-voorwaarden", label: "Algemene Voorwaarden" },
  { to: "/allergenen", label: "Allergenen" },
  { to: "/privacy", label: "Privacy" },
];

export const Footer = () => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    axios.get(`${API}/config`).then((r) => setCfg(r.data)).catch(() => {});
  }, []);
  const wa = cfg?.whatsapp_number || "31644582821";

  return (
    <footer className="bg-[#1B6B2E] text-[#F4D03F] py-14" data-testid="site-footer">
      <div className="max-w-[1200px] mx-auto w-full px-6 flex flex-col items-center text-center gap-6">
        <img src={LOGO} alt="De Zeeuwse Tori" className="w-20 h-20 rounded-full bg-white p-1 object-cover" />
        <nav className="flex flex-wrap justify-center gap-x-6 gap-y-3">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`footer-link-${l.to.replace(/\//g, "") || "home"}`}
              className="text-[#F4D03F] font-[600] hover:opacity-70 transition-opacity"
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          <a
            href={`https://wa.me/${wa}`}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-whatsapp"
            className="inline-flex items-center gap-2 font-[700] hover:opacity-70 transition-opacity"
          >
            <MessageCircle size={20} /> WhatsApp
          </a>
          <a
            href={telHref(wa)}
            data-testid="footer-phone"
            className="inline-flex items-center gap-2 font-[700] hover:opacity-70 transition-opacity"
          >
            <Phone size={20} /> {formatPhone(wa)}
          </a>
          <a
            href="mailto:info@zeeuwsetori.nl"
            data-testid="footer-email"
            className="inline-flex items-center gap-2 font-[700] hover:opacity-70 transition-opacity"
          >
            <Mail size={20} /> Email: info@zeeuwsetori.nl
          </a>
        </div>
        <p className="text-[#F4D03F] font-[400] text-sm leading-relaxed">
          Duke Ellingtonstraat #109, 4337XT, Middelburg, Zeeland, Nederland
        </p>
        <p className="text-[#F4D03F] font-[400] text-sm">
          © 2026 De Zeeuwse Tori · KVK: {cfg?.kvk_number || "42115378"} · BTW: {cfg?.btw_number || "NL005505789B34"}
        </p>
      </div>
    </footer>
  );
};
